var map = {
	"./Sample_Formatting_After.png": 739,
	"./Sample_Formatting_Before.png": 740,
	"./Sample_Outline.png": 741,
	"./Sample_Proofreading_and_formattingAfter.png": 742,
	"./Sample_Proofreading_and_formatting_Before.png": 743,
	"./Sample_Sources.png": 744,
	"./before_after_1.png": 745,
	"./before_after_cut.png": 746,
	"./icons.svg": 113,
	"./micro-1.svg": 747,
	"./micro-2.svg": 748,
	"./micro-3.svg": 749,
	"./preview1.png": 750,
	"./preview2.png": 751,
	"./preview3.png": 752,
	"./preview4.png": 753,
	"./preview5.png": 754,
	"./preview6.png": 755,
	"./services-img1.svg": 756,
	"./services-img2.svg": 757,
	"./services-img3.svg": 758,
	"./services-img4.svg": 759,
	"./source/pdf-icon.svg": 760,
	"./source/zoom-icon.svg": 761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 738;